import React from 'react'
import { find, toString, toLower, isBlank, sortBy } from 'lodash'
import Select from 'UI/Select'
import { Fragment } from 'react'

const defaultFilters = {
  customers: 'All',
  locations: 'All',
  calligoManagement: 'All',
  products: 'All',
  limitProductColumns: false
}

const Filters = ({ filters, changeFilters, customers, locations, products, hideProductFilter = false }) => {
  const filterOptions = {
    locations: sortBy(locations, 'label'),
    products: sortBy(products, 'label'),
    customers: sortBy(customers, 'label'),
    calligoManagement: [{ label: 'All', value: 'All' }, { label: 'Yes', value: true }, { label: 'No', value: false }]
  }

  return (
    <div className="row mb-3">
      <div className="col">
        <label>Location</label>
        <Select
          isMulti
          value={find(filterOptions.locations, ({ value }) => toLower(toString(filters.locations)) === toLower(toString(value)))}
          options={filterOptions.locations}
          onChange={options => changeFilters({ ...filters, locations: isBlank(options) ? 'All' : options })}
        />
      </div>

      <div className="col">
        <label>Customer</label>
        <Select
          isMulti
          value={find(filterOptions.customers, ({ value }) => toLower(toString(filters.customers)) === toLower(toString(value)))}
          options={filterOptions.customers}
          onChange={options => changeFilters({ ...filters, customers: isBlank(options) ? 'All' : options })}
        />
      </div>

      {!hideProductFilter && (
        <div className="col">
          <label className='w-100'>
            <div className="d-flex justify-content-between">
              <div>
                Products
              </div>
              <div className="d-flex align-items-center">
                {filters.products != 'All' && (
                  <Fragment>
                    <input type="checkbox" checked={filters.limitProductColumns} name="limitProductColumns" id="limitProductColumns" onChange={() => changeFilters({ ...filters, limitProductColumns: !filters.limitProductColumns })} />
                    <i style={{ paddingLeft: '5px', fontSize: '14px' }}>Show all columns</i>
                  </Fragment>
                )}
              </div>
            </div>
          </label>
          <Select
            isMulti
            value={find(filterOptions.products, ({ value }) => toLower(toString(filters.products)) === toLower(toString(value)))}
            options={filterOptions.products}
            onChange={options => changeFilters({ ...filters, products: isBlank(options) ? 'All' : options })}
          />
        </div>
      )}

      <div className="col">
        <label>Calligo Management VMs</label>
        <Select
          defaultValue={{ label: 'All', value: 'All' }}
          options={filterOptions.calligoManagement}
          onChange={option => changeFilters({ ...filters, calligoManagement: option.value })}
        />
      </div>
    </div>
  )
}

export { Filters, defaultFilters }
